/**
 * Sentry service — public import surface for the app.
 *
 * `Sentry` is a CURATED namespace of named imports, not `import * as` — the
 * namespace re-export defeated Rollup tree-shaking and shipped ~180KB minified
 * of unused SDK code (replay/feedback/replay-canvas) in the main vendor chunk.
 * Only platform-universal members belong here (this barrel is imported by both
 * hooks.client and hooks.server, which resolve to different SDK entries);
 * client-only integrations are imported directly in hooks.client.ts and
 * server-only helpers in hooks.server.ts. Add new members sparingly.
 */
import {
	addBreadcrumb,
	captureException,
	captureMessage,
	getActiveSpan,
	getRootSpan,
	handleErrorWithSentry,
	init,
	setContext,
	setMeasurement,
	setTag,
	setUser,
	startSpan,
} from '@sentry/sveltekit';

export const Sentry = {
	addBreadcrumb,
	captureException,
	captureMessage,
	getActiveSpan,
	getRootSpan,
	handleErrorWithSentry,
	init,
	setContext,
	setMeasurement,
	setTag,
	setUser,
	startSpan,
};

export {
	ABC_ATTRIBUTES,
	PAGE_INIT_RESULTS,
	PAYMENT_SDK_STATES,
	RENDERING_MODES,
	experimentRouteAttributes,
	setExperimentRouteAttributes,
	setRouteAttributes,
	toTelemetryBoolean,
} from './attributes';
export {
	afterPaint,
	declareExpectedPaymentMethods,
	instrument,
	markApplePayButtonInteractive,
	markInboundRedirectFired,
	markPaymentFormInteractive,
	markPayPalButtonInteractive,
	markQrVisible,
	markSkeletonVisible,
	markTokenReady,
	markVariantPainted,
	markVariantReady,
	noteApplePaySdkState,
	notePaypalSdkState,
	recordRouteStart,
	stampRenderingMode,
} from './instrument';
